import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { AppComponent } from "../app.component";
import { MatDialog, MatDialogConfig } from "@angular/material";
import { AlertasComponent } from "../alertas/alertas.component";
import { GlobalService } from "../global.service";
import { Subscription } from "rxjs";
import { Service } from "../services";
import { LoadingScreenService } from "../services/loading-screen/loading-screen.service";
@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.sass"],
})
export class MenuComponent implements OnInit {
  @Input() tabActive: string;
  public session: string;
  public userName: string;
  public showMenuStatus: boolean = false;
  public menuMobile: boolean = false;
  public moduleData;
  public idData = [];
  public type;
  updateTypeAccount: Subscription;
  public numberNotifications;
  public notifications;
  public notificationsCounter;
  public nameDivided;

  @Input() showUserMobile: boolean;
  constructor(
    public global: GlobalService,
    public dialog: MatDialog,
    private router: Router,
    public appComponent: AppComponent,
    private services: Service,
    private loadingScreenService: LoadingScreenService
  ) {}

  ngOnInit() {
    if (this.global.sessionReview() == true) {
      this.global.activeNavigation =
        sessionStorage.getItem("activeNavigation") == "true";
      this.notificationsCounter = JSON.parse(
        atob(sessionStorage.getItem("getAccountDetails"))
      ).Messages.newMessageCounter;
      this.notifications = JSON.parse(
        atob(sessionStorage.getItem("getAccountDetails"))
      ).Messages.MessagesList;
      this.numberNotifications = parseInt(
        JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).Messages
          .MessagesList.length
      );
      this.updateTypeAccount = this.global.uptypeAccount.subscribe(
        (value: string) => {
          this.type = value;
        }
      );
      this.session = sessionStorage.getItem("session");
      this.userName = sessionStorage.getItem("firstName");
      if (this.session == "true") {
        this.moduleData = JSON.parse(
          atob(sessionStorage.getItem("moduleData"))
        );

        console.log(this.moduleData)
      }
    }
  }
  ngAfterViewInit() {}
  goMessage(id) {
    this.router.navigate(["notification/" + id]);
  }
  messageUpdate() {
    this.global.notif(
      "Estamos realizando cambios en nuestros sistemas para mejorar su experiencia en el manejo de su cuenta de acceso. Por favor, antes de continuar su navegación, actualice los datos abajo solicitados."
    );
  }
  showMenu() {
    this.global.validateSession();
    if (this.showMenuStatus == false) {
      this.showMenuStatus = true;
    } else {
      this.showMenuStatus = false;
    }
  }
  gotTo(path) {
    console.log(path)
    if (path.trim().toLowerCase()=="https://tienda.claropr.com/") {
      this.goRun(path);
    }  else {
      if (this.global.screenEnabled == false) {
        this.global.routerReturn(path);
      }
      this.router.navigate([path]);
    }
    
   
  }
  closeMenu() {
    this.global.validateSession();
    this.showMenuStatus = false;
  }
  showMenuMobile() {
    this.global.validateSession();
    if (this.menuMobile == false) {
      this.menuMobile = true;
    } else {
      this.menuMobile = false;
    }
  }
  chat() {
    if (sessionStorage.getItem("session") != null) {
      this.global.validateSession();
    }
    this.global.irChat();
  }

  goRun(module: string) {
    console.log('tienda aca', module)
    if (module.toLowerCase() == "https://tienda.claropr.com/") {
     this.global.goStore();
    }
  }
  logout() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      message: "¿Estás seguro que deseas cerrar la sesión?",
      btmConfirm: true,
    };
    const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((value) => {
      if (value == "continue") {
        sessionStorage.clear();
        localStorage.clear();
        this.services
          .botchat(
            "",
            "",
            "",
            "599",
            "e2f7386f-32d3-44ed-8088-0133d11916c6",
            "12",
            "",
            "",
            "",
            "Web",
            ""
          )
          .subscribe(
            (data) => {
              if (data.hasError == false) {
                this.global.urlChat = data.url;
                sessionStorage.setItem("botChat", data.url);
              }
              this.router.navigate(["login"]);
            },
            (error) => {
              this.router.navigate(["login"]);
            }
          );
      }
    });
  }
  ngOnDestroy() {
    // this.updateTypeAccount.unsubscribe();
  }
}
